"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClonedSlug = exports.unSupportedClone = exports.updateSlugReferencesInFilePath = void 0;
exports.getClonedArtifactSlug = getClonedArtifactSlug;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const updateSlugReferencesInFilePath = (oldToNewSlugMap, filePath) => {
    // this function is meant to update externalFilename or other strings that
    // represent filePaths, and may have slug references.
    // something like:
    // orgSlug/creditFacilitySlug/loanProductSlug/filenamexxx.pdf
    // to be safe we are only going to replace the slugs that are delimited by /
    const tokens = filePath.split('/');
    const newTokens = tokens.map((token) => oldToNewSlugMap.get(token) || token);
    const updated = newTokens.join('/');
    return updated;
};
exports.updateSlugReferencesInFilePath = updateSlugReferencesInFilePath;
const unSupportedClone = ({ artifactToClone, }) => {
    throw new Error(`Clone operation not implemented for [artifactType:${artifactToClone.type}]`);
};
exports.unSupportedClone = unSupportedClone;
function getClonedArtifactSlug(artifactSlug, cloneMap) {
    if (artifactSlug == null) {
        return artifactSlug;
    }
    // Composite artifact slugs embed one or more entity slugs (e.g. the synthetic
    // `assignedLoanTape_${loanProductSlug}_${creditFacilitySlug}`), so we remap by
    // substring rather than a whole-slug `cloneMap.get`. This must be a SINGLE,
    // longest-match-first pass: iterating `replaceAll` per entry (the previous
    // approach) both re-scans already-substituted text (cascading) and lets a
    // short key rewrite the prefix of a longer token when one slug is a substring
    // of another (e.g. `foo` inside `fooLoanProduct`). Building one alternation
    // sorted longest-first replaces each position at most once with the longest
    // matching key, so the result matches what the synthetic slug generators
    // recompute from the (exactly-remapped) entity-slug fields on attach.
    const orderedKeys = [...cloneMap.keys()]
        .filter((key) => key.length > 0)
        .sort((keyA, keyB) => keyB.length - keyA.length);
    if (orderedKeys.length === 0) {
        return artifactSlug;
    }
    const pattern = new RegExp(orderedKeys.map(_.escapeRegExp).join('|'), 'g');
    return artifactSlug.replace(pattern, (match) => cloneMap.get(match) ?? match);
}
// for some nodes lpSlug (or cfSlug) must be null
// for some nodes lpSlug (or cfSlug) must be string
// for some nodes lpSlug (or cfSlug) can be either
// this generic function takes care of these three variation,
// it returns the cloned version of the same type.
const getClonedSlug = (slug, cloneMap) => {
    if (slug === null) {
        // TypeScript cannot infer that null satisfies the complex conditional return type,
        // so we need to cast it. This is safe because when slug is null, we always return null
        // which matches the expected return type for T extends null case.
        return null;
    }
    const clonedSlug = cloneMap.get(slug);
    (0, common_1.finleyAssert)(clonedSlug !== undefined, `Slug mapping not found for: [slug:${slug}]`);
    // TypeScript cannot infer that clonedSlug (which is string) satisfies the complex
    // conditional return type. This is safe because clonedSlug is always a string when
    // slug is a string, which matches the expected return type for T extends string case.
    return clonedSlug;
};
exports.getClonedSlug = getClonedSlug;
//# sourceMappingURL=cloneUtils.js.map